<template>
  <div class="main-container">
    <h1>Административная панель для MAX-бот</h1>
    <div class="control-container">
      <div class="class-selector">
        <label>Класс:</label>
        <select
          class="form-control"
          v-model="selectedClassSelect"
          @change="loadStudents"
          id="selected_class"
        >
          <option value="">Все классы</option>
          <option v-for="cls in classList" :key="cls._id" :value="cls">
            {{ cls.className }}
          </option>
        </select>
        <Preloader v-if="loading"></Preloader>
      </div>
    </div>

    <div class="content-container">
      <table>
        <tr>
          <th>№</th>
          <th>ФИ</th>
          <th>ID MAX</th>
          <th>ID MAX Родителя</th>
          <th>Фото ученика (ссылка)</th>
        </tr>
        <tr v-for="(stud, index) in studentsList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ stud.FirstName }} {{ stud.LastName }}</td>
          <td>
            <div v-if="stud.MaxID">
              <span class="maxbot-id">{{ stud.MaxID }}</span>
              <button
                @click="deleteMaxBotIdByStud(stud)"
                class="delete-btn"
                title="Удалить ID MAX"
              >
                ❌
              </button>
            </div>
            <div v-else>
              <v-btn
                @click="addMaxBotIdtoStudent(stud)"
                color="primary"
                style="text-align: center"
              >
                Добавить
              </v-btn>
            </div>
          </td>
          <td>
            <div v-if="stud.MaxIDparent">
              <span class="maxbot-id">{{ stud.MaxIDparent }}</span>
              <button
                @click="deleteMaxIDparentByStud(stud)"
                class="delete-btn"
                title="Удалить ID MAX"
              >
                ❌
              </button>
            </div>
            <div v-else>
              <v-btn
                @click="addMaxIDparenttoStudent(stud)"
                color="primary"
                style="text-align: center"
              >
                Добавить
              </v-btn>
            </div>
          </td>

          <td>
            <div v-if="stud.photo">
              <span class="maxbot-id"
                ><a :href="stud.photo" target="_blank" rel="noopener noreferrer"
                  >Фото</a
                ></span
              >
              <button
                @click="deletePhotoByStud(stud)"
                class="delete-btn"
                title="Удалить ID MAX"
              >
                ❌
              </button>
            </div>
            <div v-else>
              <v-btn
                @click="addPhotoToStudent(stud)"
                color="primary"
                style="text-align: center"
              >
                Добавить
              </v-btn>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import TutorialDataService from "../../services/TutorialDataService";
const Preloader = () => import("../Preloader.vue");
export default {
  components: {
    Preloader: Preloader,
  },
  props: {
    selectedClass: Object,
  },
  data() {
    return {
      studentsList: [],
      loading: false,
      classList: null,
      selectedClassSelect: null,
    };
  },
  methods: {
    async loadClassList() {
      try {
        const response = await TutorialDataService.getAllCLass();
        this.classList = response.data;
      } catch (error) {
        console.error("Ошибка загрузки классов:", error);
      }
    },
    async addMaxBotIdtoStudent(stud) {
      console.log(stud);

      // Используем стандартный prompt для получения значения
      const newMaxBotId = prompt(
        `Вы добавляете ID чата MAX для ${stud.FirstName} ${stud.LastName}. Ребенок должен передать Вам цифры, которые написал ему MAX-бот школы:`,
      );

      // Проверяем, ввел ли пользователь что-то и не нажал ли Cancel
      if (newMaxBotId !== null && newMaxBotId.trim() !== "") {
        try {
          // Показываем сообщение о начале обновления
          // alert(`Отправка ID ${newMaxBotId} на сервер...`);

          // Здесь должен быть ваш API вызов для обновления ID
          await TutorialDataService.changeMaxIDStudent({
            studentID: stud._id,
            MaxID: newMaxBotId,
          })
            .then(async (res) => {
              console.log(res);
              if (res.status == 200) {
                // Успешное сообщение
                alert(
                  `✅ ID чата MAX успешно добавлен для ${stud.FirstName} ${stud.LastName}: ${newMaxBotId}`,
                );

                // Обновляем локальные данные студента
                stud.MaxID = newMaxBotId;

                await this.loadStudents();
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } catch (error) {
          console.error("Ошибка при добавлении ID:", error);
          alert(`❌ Ошибка при добавлении ID: ${error.message}`);
        }
      } else if (newMaxBotId !== null) {
        alert("⚠️ ID не может быть пустым");
      } else {
        alert("❌ Операция отменена");
      }
    },

    async deleteMaxBotIdByStud(stud) {
      if (
        !confirm(
          `Вы уверены? Удаление ID MAX для ${stud.FirstName} ${stud.LastName}`,
        )
      ) {
        return;
      }
      // Здесь должен быть ваш API вызов для обновления ID
      await TutorialDataService.deleteMaxIDStudent({
        studentID: stud._id,
        MaxID: null,
      })
        .then((res) => {
          console.log(res);
          if (res.status == 200) {
            // Успешное сообщение
            alert(
              `✅ ID чата MAX успешно удален для ${stud.FirstName} ${stud.LastName}: `,
            );

            // Обновляем локальные данные студента
            stud.MaxID = null;
            /// this.$forceUpdate();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async addMaxIDparenttoStudent(stud) {
      console.log(stud);

      // Используем стандартный prompt для получения значения
      const newMaxBotId = prompt(
        `Вы добавляете ID чата MAX родителя для ${stud.FirstName} ${stud.LastName}. Ребенок должен передать Вам цифры, которые написал ему MAX-бот школы:`,
      );

      // Проверяем, ввел ли пользователь что-то и не нажал ли Cancel
      if (newMaxBotId !== null && newMaxBotId.trim() !== "") {
        try {
          // Показываем сообщение о начале обновления
          // alert(`Отправка ID ${newMaxBotId} на сервер...`);

          // Здесь должен быть ваш API вызов для обновления ID
          await TutorialDataService.changeMaxIDparentStudent({
            studentID: stud._id,
            MaxIDparent: newMaxBotId,
          })
            .then(async (res) => {
              console.log(res);
              if (res.status == 200) {
                // Успешное сообщение
                alert(
                  `✅ ID чата MAX родителя успешно добавлен для ${stud.FirstName} ${stud.LastName}: ${newMaxBotId}`,
                );

                // Обновляем локальные данные студента
                stud.MaxIDparent = newMaxBotId;
                await this.loadStudents();
                //this.$forceUpdate();
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } catch (error) {
          console.error("Ошибка при добавлении ID:", error);
          alert(`❌ Ошибка при добавлении ID: ${error.message}`);
        }
      } else if (newMaxBotId !== null) {
        alert("⚠️ ID не может быть пустым");
      } else {
        alert("❌ Операция отменена");
      }
    },
    async deleteMaxIDparentByStud(stud) {
      if (
        !confirm(
          `Вы уверены? Удаление ID MAX родителя для ${stud.FirstName} ${stud.LastName}`,
        )
      ) {
        return;
      }
      // Здесь должен быть ваш API вызов для обновления ID
      await TutorialDataService.deleteMaxIDparentStudent({
        studentID: stud._id,
        MaxIDparent: null,
      })
        .then((res) => {
          console.log(res);
          if (res.status == 200) {
            // Успешное сообщение
            alert(
              `✅ ID чата MAX родителя успешно удален для ${stud.FirstName} ${stud.LastName}: `,
            );

            // Обновляем локальные данные студента
            stud.MaxIDparent = null;
            // this.$forceUpdate();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async addPhotoToStudent(stud) {
      let photo = prompt("Вставьте ссылку на фото");
      await TutorialDataService.updateStudentPhoto(stud._id, {
        photo: photo,
      }).then(async (data) => {
        console.log(data);
        await this.loadStudents();
      });
    },
    async deletePhotoByStud(stud) {
      if (
        !confirm(
          `Вы уверены? Удаление фото для ${stud.FirstName} ${stud.LastName}`,
        )
      ) {
        return;
      }
      // Здесь должен быть ваш API вызов для обновления ID
      await TutorialDataService.updateStudentPhoto(stud._id, {
        photo: null,
      })
        .then(async (res) => {
          console.log(res);
          if (res.status == 200) {
            // Успешное сообщение
            alert(
              `✅ Фото успешно удалено для ${stud.FirstName} ${stud.LastName}: `,
            );

            // Обновляем локальные данные студента
            //stud.photo = null;
            //this.$forceUpdate();

            this.loadStudents();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async loadStudents() {
      try {
        let params = {};
        if (this.selectedClass.classID != "admin") {
          params.classID = this.selectedClass.classID;
          document.getElementById("selected_class").disabled = true;
        } else if (this.selectedClassSelect && this.selectedClassSelect._id) {
          params.classID = this.selectedClassSelect._id;
        }
        this.loading = true;

        const response = await TutorialDataService.findStudentByClassID(params);

        const studentsObject = response.data || response;
        const studentsArray = Object.values(studentsObject);

        this.studentsList = studentsArray.map((student) => {
          this.loading = false;
          return student;
        });
      } catch (error) {
        console.error("Ошибка загрузки студентов:", error);
        this.studentsList = [];
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.loadClassList();

    if (this.selectedClass.classID != "admin") {
      //   document.getElementById("selected_class").disabled = true;

      this.loadStudents();
    }
  },
};
</script>

<style scoped>
.main-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

h1 {
  color: #2c3e50;
  font-size: 2rem;
  margin-bottom: 24px;
  font-weight: 600;
  border-bottom: 3px solid #3498db;
  padding-bottom: 12px;
  display: inline-block;
}

.control-container {
  min-height: 60px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 12px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.content-container {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.content-container:hover {
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  font-size: 0.95rem;
}

th {
  background: linear-gradient(135deg, #3fa1f9fe, 0%, #8246e1fd 100%);
  color: white;
  font-weight: 600;
  padding: 16px 20px;
  text-align: left;
  font-size: 1rem;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

th:first-child {
  border-top-left-radius: 8px;
}

th:last-child {
  border-top-right-radius: 8px;
}

td {
  padding: 14px 20px;
  border-bottom: 1px solid #eef2f6;
  border: #2c3e50 1px solid;
  color: #2c3e50;
}

tr {
  transition: all 0.2s ease;
}

tr:hover {
  background-color: #f8faff;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
}

tr:last-child td {
  border-bottom: none;
}

/* Стили для ячеек с номерами */
td:first-child {
  font-weight: 600;
  color: #667eea;
  width: 60px;
}

/* Стили для ячеек с ФИ */
td:nth-child(2) {
  font-weight: 500;
}

/* Состояние загрузки */
.loading-overlay {
  position: relative;
  min-height: 200px;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .main-container {
    padding: 12px;
  }

  h1 {
    font-size: 1.5rem;
  }

  th {
    padding: 12px 10px;
    font-size: 0.9rem;
  }

  td {
    padding: 10px;
    font-size: 0.85rem;
  }

  .content-container {
    overflow-x: auto;
  }

  table {
    min-width: 600px;
  }
}

/* Анимация появления данных */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

tr {
  animation: fadeIn 0.3s ease forwards;
}

/* Стили для пустого состояния */
.content-container:empty::before {
  content: "Нет данных для отображения";
  display: block;
  padding: 40px;
  text-align: center;
  color: #95a5a6;
  font-style: italic;
}

/* Кастомный скроллбар для таблицы */
.content-container::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.content-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.content-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #3fa1f9fe 0%, #8246e1fd 100%);
  border-radius: 4px;
}

.content-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #8246e1fd 0%, #3fa1f9fe 100%);
}

/* Стили для четных/нечетных строк для лучшей читаемости */
tr:nth-child(even) {
  background-color: #fafbfe;
}

tr:nth-child(even):hover {
  background-color: #f8faff;
}
</style>
